import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App";
import "./ui/tema.css";

const fila = new QueryClient({
  defaultOptions: {
    queries: {
      // Uma caixa de e-mail muda sozinha. 30s evita refazer a lista a cada
      // troca de pasta sem deixar o usuário olhando dado velho.
      staleTime: 30_000,
      // Não repetir 401, 403 e 404: o cliente já renova o token sozinho, e
      // repetir um 404 só atrasa a mensagem de erro em três tentativas.
      retry: (tentativas, erro) => {
        const status = (erro as { status?: number })?.status;
        if (status && status < 500) return false;
        return tentativas < 2;
      },
    },
  },
});

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={fila}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
